import product1 from "./assets/1.png";
import product2 from "./assets/2.png";
import product3 from "./assets/3.png";
import product4 from "./assets/4.png";
import product5 from "./assets/nike hd.png";
import product6 from "./assets/6.webp";
import product7 from "./assets/nike football 1.svg";
import product8 from "./assets/adidas hoodie.jpg";
import product9 from "./assets/8.webp";


export const PRODUCTS = [
  {
    id: 1,
    productName: "IPhone",
    price: 999.0,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Macbook Pro 2022 (M1)",
    price: 1999.0,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Cannon M50 Camera",
    price: 699.0,
    productImage: product3,
  },
  {
    id: 4,
    productName: "WLS Van Gogh Denim Jacket",
    price: 228.0,
    productImage: product4,
  },
  {
    id: 5,
    productName: "Nike Air",
    price: 100.00,
    productImage: product5,
  },
  {
    id: 6,
    productName: "SPECTRUM LS TEE",
    price: 68.0,
    productImage: product6,
  },
  {
    id: 7,
    productName: "ADIDAS OFFICIAL WORLD CUP FOOTBALL",
    price: 100.0,
    productImage: product7,
  },
  {
    id: 8,
    productName: "ADIDAS HOODIE",
    price: 40.0,
    productImage: product8,
  },
  {
    id: 9,
    productName: "DONT TRIP CAP",
    price: 40.0,
    productImage: product9,
  },
];